import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import RelatedBlogPosts from '../../components/feature/RelatedBlogPosts';

const serviceAreas = [
  { 
    city: 'Toronto', 
    region: 'Toronto', 
    slug: 'toronto', 
    installations: '8,500+', 
    tagline: 'Protecting Canada\'s largest city with advanced security solutions',
    neighborhoods: ['Downtown', 'North York', 'Scarborough', 'Etobicoke']
  },
  { 
    city: 'Mississauga', 
    region: 'Peel Region', 
    slug: 'mississauga', 
    installations: '5,200+', 
    tagline: 'Securing Peel Region\'s business hub and residential communities',
    neighborhoods: ['Port Credit', 'Streetsville', 'Meadowvale', 'Erin Mills']
  },
  { 
    city: 'Brampton', 
    region: 'Peel Region', 
    slug: 'brampton', 
    installations: '3,800+', 
    tagline: 'Protecting one of Canada\'s fastest-growing cities',
    neighborhoods: ['Bramalea', 'Heart Lake', 'Springdale', 'Castlemore']
  },
  { 
    city: 'Oakville', 
    region: 'Halton Region', 
    slug: 'oakville', 
    installations: '2,400+', 
    tagline: 'Premium security for luxury homes and estates',
    neighborhoods: ['Bronte', 'Glen Abbey', 'River Oaks', 'Old Oakville']
  },
  { 
    city: 'Hamilton', 
    region: 'Hamilton', 
    slug: 'hamilton', 
    installations: '2,100+', 
    tagline: 'Comprehensive security for the Steel City',
    neighborhoods: ['Westdale', 'Dundas', 'Ancaster', 'Stoney Creek']
  },
  { 
    city: 'Richmond Hill', 
    region: 'York Region', 
    slug: 'richmond-hill', 
    installations: '1,800+', 
    tagline: 'Advanced security for York Region\'s growing communities',
    neighborhoods: ['Oak Ridges', 'Jefferson', 'Bayview Hill', 'Elgin Mills']
  },
  { 
    city: 'Vaughan', 
    region: 'York Region', 
    slug: 'vaughan', 
    installations: '2,200+', 
    tagline: 'Protecting Vaughan Metropolitan Centre and beyond',
    neighborhoods: ['Woodbridge', 'Maple', 'Kleinburg', 'Thornhill']
  },
  { 
    city: 'Whitby', 
    region: 'Durham Region', 
    slug: 'whitby', 
    installations: '1,400+', 
    tagline: 'Trusted security across Durham Region',
    neighborhoods: ['Downtown', 'Brooklin', 'Ashburn', 'Port Whitby']
  },
  { 
    city: 'Ajax', 
    region: 'Durham Region', 
    slug: 'ajax', 
    installations: '1,200+', 
    tagline: 'Securing Ajax\'s growing residential communities',
    neighborhoods: ['Pickering Village', 'South Ajax', 'North Ajax', 'Salem']
  },
  { 
    city: 'Oshawa', 
    region: 'Durham Region', 
    slug: 'oshawa', 
    installations: '1,500+', 
    tagline: 'Protecting Oshawa\'s homes and businesses',
    neighborhoods: ['Downtown', 'Northwood', 'Samac', 'Lakeview']
  }
];

const totalInstallations = serviceAreas.reduce((sum, area) => {
  const num = parseInt(area.installations.replace(/[^0-9]/g, ''));
  return sum + num;
}, 0);

export default function ServiceAreasPage() {
  const scrollToContact = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  const serviceAreasStructuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://alliancesecuritysystems.com/' },
        { '@type': 'ListItem', position: 2, name: 'Service Areas', item: 'https://alliancesecuritysystems.com/service-areas' },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Alliance Security Systems — GTA Service Areas',
      description: 'Cities served by Alliance Security Systems across the Greater Toronto Area.',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Toronto Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/toronto' },
        { '@type': 'ListItem', position: 2, name: 'Mississauga Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/mississauga' },
        { '@type': 'ListItem', position: 3, name: 'Brampton Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/brampton' },
        { '@type': 'ListItem', position: 4, name: 'Oakville Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/oakville' },
        { '@type': 'ListItem', position: 5, name: 'Hamilton Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/hamilton' },
        { '@type': 'ListItem', position: 6, name: 'Richmond Hill Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/richmond-hill' },
        { '@type': 'ListItem', position: 7, name: 'Vaughan Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/vaughan' },
        { '@type': 'ListItem', position: 8, name: 'Whitby Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/whitby' },
        { '@type': 'ListItem', position: 9, name: 'Ajax Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/ajax' },
        { '@type': 'ListItem', position: 10, name: 'Oshawa Security Systems', url: 'https://alliancesecuritysystems.com/service-areas/oshawa' },
      ],
    },
  ];

  return (
    <>
      <SEO
        title="Service Areas - GTA Security Systems | Toronto, Mississauga, Brampton & 10 Cities"
        description="Professional security system installation across the Greater Toronto Area. Serving Toronto, Mississauga, Brampton, Hamilton, Vaughan, Richmond Hill, Oakville, Whitby, Ajax, and Oshawa with 30,000+ installations since 1999."
        keywords="security systems GTA, Toronto security installation, Mississauga alarm systems, Brampton security, Hamilton security, Vaughan security cameras, Richmond Hill access control, Oakville home security, Durham Region security, service areas"
        canonical="/service-areas"
        structuredData={serviceAreasStructuredData}
      />

      {/* Hero Section */}
      <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/7025a7bb5dbbcc12cd682eb0ad948e2f.jpg" 
            alt="Greater Toronto Area Skyline"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/85 via-[#0A1628]/75 to-[#0A1628]/90"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center py-20">
          <span className="inline-block bg-[#D4A853] text-white px-6 py-2 rounded-full text-sm font-semibold mb-6 whitespace-nowrap">
            SERVING THE GREATER TORONTO AREA
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight">
            Protecting the Greater Toronto Area Since 1999
          </h1>
          <p className="text-xl sm:text-2xl text-white/90 max-w-3xl mx-auto mb-8">
            Trusted local security experts serving 10 cities across the GTA with professional alarm systems, HD cameras, and 24/7 monitoring
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="tel:18884589181"
              className="bg-[#D4A853] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#B8923D] transition-all cursor-pointer whitespace-nowrap shadow-xl flex items-center gap-2"
            >
              <i className="ri-phone-line text-xl"></i>
              Call 1-888-458-9181
            </a>
            <Link
              to="/contact"
              className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-[#0A1628] transition-all cursor-pointer whitespace-nowrap"
            >
              Get Free Quote
            </Link>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <nav className="bg-white border-b border-gray-100 py-3" aria-label="Breadcrumb">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <ol className="flex items-center gap-2 text-xs text-gray-500" itemScope itemType="https://schema.org/BreadcrumbList">
            <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <Link to="/" className="hover:text-[#D4A853] transition-colors cursor-pointer" itemProp="item">
                <span itemProp="name">Home</span>
              </Link>
              <meta itemProp="position" content="1" />
            </li>
            <li className="flex items-center"><i className="ri-arrow-right-s-line text-gray-400"></i></li>
            <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <span className="text-[#D4A853] font-medium" itemProp="name">Service Areas</span>
              <meta itemProp="position" content="2" />
            </li>
          </ol>
        </div>
      </nav>

      {/* Stats Bar */}
      <section className="bg-[#0A1628] border-y border-[#D4A853]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <p className="text-4xl md:text-5xl font-bold text-[#D4A853] mb-2">{totalInstallations.toLocaleString()}+</p>
              <p className="text-white/70 text-sm">Total Installations</p>
            </div>
            <div className="text-center">
              <p className="text-4xl md:text-5xl font-bold text-[#D4A853] mb-2">10</p>
              <p className="text-white/70 text-sm">Cities Served</p>
            </div>
            <div className="text-center">
              <p className="text-4xl md:text-5xl font-bold text-[#D4A853] mb-2">25+</p>
              <p className="text-white/70 text-sm">Years Experience</p>
            </div>
            <div className="text-center">
              <p className="text-4xl md:text-5xl font-bold text-[#D4A853] mb-2">4.9★</p>
              <p className="text-white/70 text-sm">Average Rating</p>
            </div>
          </div>
        </div>
      </section>

      {/* City Cards Grid */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0A1628] mb-4">
              Our Service Areas
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Professional security installation and monitoring across the Greater Toronto Area
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {serviceAreas.map((area) => (
              <Link
                key={area.slug}
                to={`/service-areas/${area.slug}`}
                className="group bg-gradient-to-br from-[#F8F9FA] to-white border border-gray-200 rounded-2xl p-6 md:p-8 hover:shadow-2xl hover:border-[#D4A853]/50 transition-all duration-300 hover:-translate-y-2"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h3 className="text-2xl md:text-3xl font-bold text-[#0A1628] group-hover:text-[#D4A853] transition-colors mb-2">
                      {area.city}
                    </h3>
                    <span className="inline-block bg-[#0A1628]/10 text-[#0A1628] px-3 py-1 rounded-full text-xs font-semibold">
                      {area.region}
                    </span>
                  </div>
                  <div className="bg-[#D4A853]/10 text-[#D4A853] px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap ml-3">
                    {area.installations}
                  </div>
                </div>

                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {area.tagline}
                </p>

                <div className="mb-6">
                  <p className="text-xs font-semibold text-gray-500 mb-2">NEIGHBORHOODS SERVED:</p>
                  <div className="flex flex-wrap gap-2">
                    {area.neighborhoods.map((neighborhood, idx) => (
                      <span 
                        key={idx}
                        className="text-xs bg-white border border-gray-200 text-gray-600 px-3 py-1 rounded-full"
                      >
                        {neighborhood}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex items-center text-[#D4A853] font-semibold group-hover:gap-3 transition-all">
                  <span>View {area.city} Page</span>
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Google Maps Section */}
      <section className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <span className="inline-block bg-[#D4A853]/10 text-[#D4A853] px-6 py-2 rounded-full text-sm font-semibold mb-4 whitespace-nowrap">
              OUR COVERAGE AREA
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0A1628] mb-4">
              Serving the Entire Greater Toronto Area
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              From Toronto to Hamilton, Oakville to Oshawa—we protect homes and businesses across the GTA
            </p>
          </div>
          
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d369107.5010346443!2d-79.6426656!3d43.7184038!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2a1d7471fd93%3A0x4ecad8e272e4c2a2!2sGreater%20Toronto%20Area%2C%20ON!5e0!3m2!1sen!2sca!4v1234567890"
              width="100%"
              height="600"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Greater Toronto Area Service Coverage Map"
            ></iframe>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="w-12 h-12 bg-[#D4A853]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-2xl text-[#D4A853]"></i>
              </div>
              <h3 className="font-bold text-[#0A1628] mb-2">Toronto Core</h3>
              <p className="text-sm text-gray-600">Downtown, North York, Scarborough, Etobicoke</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="w-12 h-12 bg-[#D4A853]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-2xl text-[#D4A853]"></i>
              </div>
              <h3 className="font-bold text-[#0A1628] mb-2">Peel Region</h3>
              <p className="text-sm text-gray-600">Mississauga, Brampton</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="w-12 h-12 bg-[#D4A853]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-2xl text-[#D4A853]"></i>
              </div>
              <h3 className="font-bold text-[#0A1628] mb-2">York Region</h3>
              <p className="text-sm text-gray-600">Vaughan, Richmond Hill</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="w-12 h-12 bg-[#D4A853]/10 rounded-full flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-2xl text-[#D4A853]"></i>
              </div>
              <h3 className="font-bold text-[#0A1628] mb-2">Durham & Beyond</h3>
              <p className="text-sm text-gray-600">Whitby, Ajax, Oshawa, Hamilton, Oakville</p>
            </div>
          </div>
        </div>
      </section>

      {/* Related Blog Posts */}
      <RelatedBlogPosts city="service-areas" />

      {/* Why a Local Expert Matters */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <span className="inline-block bg-[#D4A853]/10 text-[#D4A853] px-6 py-2 rounded-full text-sm font-semibold mb-4 whitespace-nowrap">
              LOCAL EXPERTISE
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0A1628] mb-4">
              Why Choose a Local Security Expert?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Being local means faster response, better service, and deep knowledge of your community
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            <div className="bg-[#F8F9FA] rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
              <div className="w-16 h-16 bg-[#D4A853] rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#0A1628] mb-4">Faster Response Times</h3>
              <p className="text-gray-600 leading-relaxed">
                Local technicians arrive quickly for installations, repairs, and emergencies. Same-day service available across the GTA.
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
              <div className="w-16 h-16 bg-[#D4A853] rounded-full flex items-center justify-center mb-6">
                <i className="ri-map-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#0A1628] mb-4">Local Knowledge</h3>
              <p className="text-gray-600 leading-relaxed">
                We understand GTA neighborhoods, local crime patterns, and specific security challenges in your area.
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
              <div className="w-16 h-16 bg-[#D4A853] rounded-full flex items-center justify-center mb-6">
                <i className="ri-community-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#0A1628] mb-4">Community Trust</h3>
              <p className="text-gray-600 leading-relaxed">
                25 years serving your neighbors. Check our local references and see our work throughout your community.
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
              <div className="w-16 h-16 bg-[#D4A853] rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#0A1628] mb-4">Ontario Certified</h3>
              <p className="text-gray-600 leading-relaxed">
                Fully licensed and insured in Ontario. We know local building codes, bylaws, and insurance requirements.
              </p>
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-r from-[#0A1628] to-[#1a2d4a] rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                  Local Service, National Standards
                </h3>
                <p className="text-white/80 mb-6">
                  We combine the personalized service of a local business with the expertise and technology of industry leaders. Factory-certified technicians, premium equipment, and 24/7 professional monitoring.
                </p>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <i className="ri-shield-star-line text-[#D4A853] text-2xl"></i>
                    <span className="text-white/90 text-sm">Licensed & Insured</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-award-line text-[#D4A853] text-2xl"></i>
                    <span className="text-white/90 text-sm">BBB A+ Rated</span>
                  </div>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <p className="text-white/60 text-sm mb-2">Average Response Time</p>
                <p className="text-5xl font-bold text-[#D4A853] mb-4">&lt;2 Hours</p>
                <p className="text-white/80 text-sm">
                  Emergency service calls answered and dispatched within 2 hours across all GTA service areas
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 md:py-24 bg-[#0A1628] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
            Ready to Protect Your Property?
          </h2>
          <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto">
            Get a free security assessment from our local experts. We'll design a custom solution for your home or business.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="tel:18884589181"
              className="bg-[#D4A853] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#B8923D] transition-all cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 shadow-xl"
            >
              <i className="ri-phone-line text-xl"></i>
              Call 1-888-458-9181
            </a>
            <Link
              to="/contact"
              className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
            >
              <i className="ri-mail-line text-xl"></i>
              Request Free Quote
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <i className="ri-calendar-check-line text-3xl text-[#D4A853] mb-3"></i>
              <p className="text-white font-semibold mb-1">Same-Day Service</p>
              <p className="text-white/60 text-sm">Available across the GTA</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <i className="ri-money-dollar-circle-line text-3xl text-[#D4A853] mb-3"></i>
              <p className="text-white font-semibold mb-1">Free Consultation</p>
              <p className="text-white/60 text-sm">No obligation quotes</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <i className="ri-customer-service-2-line text-3xl text-[#D4A853] mb-3"></i>
              <p className="text-white font-semibold mb-1">24/7 Support</p>
              <p className="text-white/60 text-sm">Always here when you need us</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
